import {useGlobalCustomPreference} from '../hooks/use-custom-preference'
import regionsConfigFallback from './static/regionsConfig.json'

/**
 * Custom hook to retrieve region configuration.
 *
 * This hook attempts to fetch the region configuration using a global custom preference.
 * If the custom preference is not available, it falls back to a static JSON configuration.
 *
 * @returns {Object} The region configuration object.
 */
const useRegions = () => {
    const regions = useGlobalCustomPreference('regionConfig')

    return regions || regionsConfigFallback
}

export default useRegions
